// utils/api/DocumentEditorApi/DocumentApi.js

import { apiCall } from '../ApiUtils';

export const documentApi = {
  // Document saving function
  saveDocument: (title, content, author, classContext = null) =>
    apiCall('/document-editor/save-document', {
      method: 'POST',
      body: JSON.stringify({
        title,
        content,
        author
      })
    }, classContext),

  // Document Management Functions
  getDocuments: (folderId = null, classContext = null) =>
    apiCall(`/document-editor/documents${folderId ? `?folderId=${folderId}` : ''}`, {
      method: 'GET'
    }, classContext),

  getDocument: (documentId, classContext = null) =>
    apiCall(`/document-editor/documents/${documentId}`, {
      method: 'GET'
    }, classContext),

  createDocument: (title, content, folderId = null, sectionId = null, handler = '', classContext = null) =>
    apiCall('/document-editor/documents', {
      method: 'POST',
      body: JSON.stringify({
        title,
        content,
        folderId,
        sectionId,
        handler
      })
    }, classContext),

  createDocumentWithQuestions: (title, content, questions, folderId = null, handler = '', classContext = null) =>
    apiCall('/document-editor/create-document-with-questions', {
      method: 'POST',
      body: JSON.stringify({
        title,
        content,
        questions,
        folderId,
        handler
      })
    }, classContext),

  updateDocument: (documentId, title, content, handler = null, classContext = null) =>
    apiCall(`/document-editor/documents/${documentId}`, {
      method: 'PUT',
      body: JSON.stringify({
        title,
        content,
        ...(handler !== null && { handler })
      })
    }, classContext),

  renameDocument: (documentId, newTitle, classContext = null) =>
    apiCall(`/document-editor/documents/${documentId}/rename`, {
      method: 'PATCH',
      body: JSON.stringify({
        title: newTitle
      })
    }, classContext),

  deleteDocument: (documentId, classContext = null) =>
    apiCall(`/document-editor/documents/${documentId}`, {
      method: 'DELETE'
    }, classContext),

  moveDocument: (documentId, newFolderId, classContext = null) =>
    apiCall(`/document-editor/documents/${documentId}/move`, {
      method: 'PATCH',
      body: JSON.stringify({
        folderId: newFolderId
      })
    }, classContext),

  // Folder Management Functions
  getFolders: (parentId = null, classContext = null) =>
    apiCall(`/document-editor/folders${parentId ? `?parentId=${parentId}` : ''}`, {
      method: 'GET'
    }, classContext),

  getFolder: (folderId, classContext = null) =>
    apiCall(`/document-editor/folders/${folderId}`, {
      method: 'GET'
    }, classContext),

  createFolder: (name, parentId = null, classContext = null) =>
    apiCall('/document-editor/folders', {
      method: 'POST',
      body: JSON.stringify({
        name,
        parentId
      })
    }, classContext),

  renameFolder: (folderId, newName, classContext = null) =>
    apiCall(`/document-editor/folders/${folderId}/rename`, {
      method: 'PATCH',
      body: JSON.stringify({
        name: newName
      })
    }, classContext),

  deleteFolder: (folderId, classContext = null) =>
    apiCall(`/document-editor/folders/${folderId}`, {
      method: 'DELETE'
    }, classContext),

  moveFolder: (folderId, newParentId, classContext = null) =>
    apiCall(`/document-editor/folders/${folderId}/move`, {
      method: 'PATCH',
      body: JSON.stringify({
        parentId: newParentId
      })
    }, classContext),
};